import { BannerVariant } from '../types/Banner';
import { HowToOpen } from '../types/common';

export const BannerUsers = {
    All: 'all',
    LoggedIn: 'loggedIn',
    LoggedOut: 'loggedOut',
    NewUserDevice: 'newUser',
    ReturningUserDevice: 'returningUser',
} as const;
export type BannerUsers = typeof BannerUsers[keyof typeof BannerUsers];

export const BannerType = {
    Link: 'link',
    Sport: 'sport',
    Casino: 'casino',
} as const;
export type BannerType = typeof BannerType[keyof typeof BannerType];

export type BannerAdditionalData =
    | Record<string, never> // empty object
    | BannerCasinoAdditionalData
    | BannerLinkAdditionalData
    | BannerSportAdditionalData
    | BannerRegistrationStep;

type BannerLinkAdditionalData = {
    link?: string;
    deeplink?: string;
};

type BannerSportAdditionalData = {
    id: number;
    name: string;
    subType: 'tournament' | 'event' | 'competition';
};

type BannerCasinoAdditionalData = {
    name: string;
    externalIdDesktop: string | null;
    externalIdMobile: string | null;
};

type BannerRegistrationStep = {
    step?: number
};
export default interface BannerDto {
    id: number;
    title: string;
    backgroundImage: string;
    image: string | null;
    users: BannerUsers[];
    type: BannerType;
    additionalData: BannerAdditionalData;
    link: string;
    description: string | null;
    callToActionText: string | null;
    startDateMs: number;
    endDateMs: number;
    variant: BannerVariant;
    buttonText: string;
    iconName: string;
    // there are some problems with CMS fastly refreshing when we add new field
    // null should be removed in a month or two when this is fixed
    howToOpen?: HowToOpen;
}
